import {ApiPublicErrorUtil, IApiPublicError, IApiPublicErrorTyped} from "../../common/ApiPublicError";
import {SimulcastErrorAction} from "../../stream/simulcast/SimulcastTypes";

enum PrivacyStatus {
    Private = "private",
    Public = "public",
    Unlisted = "unlisted"
}

enum IngestionType {
    Dash = "dash",
    Hls = "hls",
    Rtmp = "rtmp"
}

interface IYTErrorItem {
    domain: string;
    reason: string;
    message: string;
    locationType: string;
    location: string;
}

interface IYTErrorResponse {
    errors: IYTErrorItem[];
    code: number;
    message: string;
}

class YoutubeUtil{

    static getYTErrorAction(errCode: string): SimulcastErrorAction {

        // if(FBErrorsReconnect.has(errCode) || errCode.toLowerCase() == "OAuthException".toLowerCase()){
        //     return SimulcastErrorAction.Reconnect;
        // } else if(FBErrorsTryAgain.has(errCode)){
        //     return SimulcastErrorAction.TryAgainLater;
        // } else {
        //     return SimulcastErrorAction.Delete;
        // }

        return SimulcastErrorAction.Delete;
    }

    static toYTError(err: IApiPublicError): IApiPublicErrorTyped<IYTErrorResponse> {
        return ApiPublicErrorUtil.toTypedError<IYTErrorResponse>("yterrorobj", err);
    }
}

export { IngestionType, PrivacyStatus, YoutubeUtil, IYTErrorResponse}